import React from "react";
import contact from "../static/images/call.png";
import contactMobile from "../static/images/callMobile.png";
import email from "../static/images/email.png";
import emailMobile from "../static/images/emailMobile.png";
import whatsappMobile from "../static/images/whatsappMobile.png";
import whatsapp from "../static/images/whatsapp.png";
import "../static/getinTouch.css";
function GetinTouch() {
  return (
    <div className="containerFluid mt-5 ombreBrandsContainer">
      <div className="row">
        <div className="col-xl-12 col-lg-12 col-md-12 text-xl-start text-lg-start text-md-start  m-xl-auto m-lg-auto m-md-auto  mx-sm-auto  mt-sm-5  mx-auto mt-5 order-xl-2 order-lg-2 order-md-2  order-sm-1 order-1 p-0">
          <div className="conductEventsTitle successEventTitle text-center col-xl-12 col-lg-12 col-md-12 m-auto">
            Get in touch with Us
          </div>
          <div className="d-flex flex-column curatedDescription margin-top-9 justify-content-center align-items-center">
            <div className="d-flex flex-row  mb-xl-5 mb-lg-5 mb-md-5 m-auto ">
              <img
                src={contact}
                alt="contact number"
                className="d-none d-xl-block d-lg-block d-md-block d-sm-none d-none"
              ></img>
              <img
                src={contactMobile}
                alt="contact number"
                className="d-none d-xl-none d-lg-none d-md-none d-sm-block d-block call"
              ></img>

              <div className="c pl-xl-3 pl-lg-3 pl-md-3">+91 8084078747</div>
            </div>
            <div className="d-flex flex-row mb-xl-5 mb-lg-5 mb-md-5 m-auto">
              <img
                src={email}
                alt="email"
                className="d-none d-xl-block d-lg-block d-md-block d-sm-none d-none"
              ></img>
              <img
                src={emailMobile}
                alt="contact number"
                className="d-none d-xl-none d-lg-none d-md-none d-sm-block d-block email"
              ></img>

              <div className=" pl-xl-3 pl-lg-3 pl-md-3">
                livewithombre@gmail.com
              </div>
            </div>
            <div className="d-flex flex-row mb-xl-5 mb-lg-5 mb-md-5 m-auto">
              <img
                src={whatsapp}
                alt="whatsapp"
                className="d-none d-xl-block d-lg-block d-md-block d-sm-none d-none"
              ></img>
              <img
                src={whatsappMobile}
                alt="contact number"
                className="d-none d-xl-none d-lg-none d-md-none d-sm-block d-block whatsapp"
              ></img>
              <div className=" pl-xl-3 pl-lg-3 pl-md-3">+91 8210491173</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GetinTouch;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/components/GetinTouch.jsx